// extracted by mini-css-extract-plugin
export default {"number":"positions_number__vimHL","removeButton":"positions_removeButton__zw4nk"};